var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "no-results basic-formatting" },
    [
      _vm.hasMiniferieDuration
        ? [
            _c("p", [_vm._v(_vm._s(_vm.translations.search.noResult.intro))]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.translations.search.noResult.hasMiniferie)),
            ]),
            _vm._v(" "),
            _vm.isFetching
              ? _c("Spinner")
              : _vm.lodgings.length > 0
              ? _vm._l(_vm.lodgings, function (lodging, index) {
                  return _c("FeriehusItem", {
                    key: lodging.position,
                    attrs: { lodging: lodging },
                  })
                })
              : _vm._e(),
          ]
        : [
            _c("p", [_vm._v(_vm._s(_vm.translations.search.noResult.intro))]),
            _vm._v(" "),
            _c("search-tags-display"),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(_vm._s(_vm.translations.search.noResult.listStart)),
              ]),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [_vm._v(_vm._s(_vm.translations.search.noResult.tip1))]),
              _vm._v(" "),
              _c("li", [_vm._v(_vm._s(_vm.translations.search.noResult.tip2))]),
              _vm._v(" "),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.translations.search.noResult.tip3),
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClickable($event, "freetext")
                  },
                },
              }),
              _vm._v(" "),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(_vm.translations.search.noResult.tip4),
                },
                on: {
                  click: function ($event) {
                    return _vm.handleClickable($event, "all")
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [
                _vm._v(_vm._s(_vm.translations.search.noResult.outro1)),
              ]),
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.translations.search.noResult.outro2))]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }